<template>
    <div>
        <div v-if="data.links.length" class="bg-white border rounded mb-2">
            <draggable
                v-model="data.links"
                handle=".link-handle"
                item-key="$index"
                :animation="150"
                class="divide-y"
            >
                <template #item="{ element: link, index }">
                    <div class="p-3 space-y-2">
                        <div class="flex items-center justify-between">
                            <div class="flex items-center gap-2">
                                <button type="button" class="link-handle cursor-move focus:outline-none">
                                    <svg class="w-4 h-4 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                                </button>
                                <span class="text-sm text-gray-900">Link {{ index + 1 }}</span>
                            </div>
                            <btn type="light" size="xs" @click="removeLink(link)">
                                <icon name="delete" size="14" class="mr-1" />
                                Delete
                            </btn>
                        </div>
                        <div class="grid grid-cols-2 gap-2">
                            <text-field
                                v-model="link.title"
                                placeholder="Title"
                            />
                            <text-field
                                v-model="link.url"
                                :prefixes="['https://', 'http://']"
                                placeholder="https://"
                            />
                        </div>
                        <text-field
                            v-model="link.description"
                            placeholder="Description (optional)"
                        />
                    </div>
                </template>
            </draggable>
        </div>

        <div class="flex items-center justify-between">
            <btn type="secondary" size="small" @click="addLink">Add link</btn>
            <div v-if="data.links.length" class="flex items-center">
                <div v-if="data.display_in_columns" class="flex items-center mr-2">
                    <span class="text-xs text-gray-500 mr-1">Columns:</span>
                    <select
                        :value="data.columns_count"
                        @change="data.columns_count = Number($event.target.value)"
                        class="border-0 focus:ring-0 leading-4 text-xs text-gray-500 p-0 pr-6 bg-transparent cursor-pointer"
                    >
                        <option value="2">2</option>
                        <option value="3">3</option>
                    </select>
                </div>
                <toggle
                    size="medium"
                    @update:model-value="data.display_in_columns = $event"
                    :model-value="data.display_in_columns ?? false"
                >
                </toggle>
                <span class="text-sm font-medium">Display in columns</span>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';

export default {
    props: ['unique_id', 'data'],
    components: {
        draggable,
    },
    created() {
        this.data.links = this.data?.links ?? [];
        if (!this.data.columns_count) {
            this.data.columns_count = 3;
        }
    },
    methods: {
        addLink() {
            this.data.links.push({
                type: 'link',
                title: '',
                url: '',
                description: '',
            });
        },
        removeLink(link) {
            this.data.links = this.data.links.filter((item) => item !== link);
        }
    }
}
</script>
